import React, { useEffect, useState } from 'react';
import { academicProgramsService } from '../../../../services';

const ProgramCard = ({ heading, program }) => (
    <div className="flex-1">
        <div className="text-muted small font-weight-bold mb-2">{heading}</div>
        <div className="border rounded p-3 bg-light h-100">
            <div>
                <strong>{program?.programName || <span className="text-muted">—</span>}</strong>
                {program?.programId
                    ? <span className="text-muted ml-2">(ID: {program.programId})</span>
                    : null}
            </div>
            <div className="text-muted small mt-1">
                {program?.cipCode
                    ? <span className="mr-3">CIP: {program.cipCode}{program.cipTitle ? ` — ${program.cipTitle}` : ''}</span>
                    : null}
                {program?.degreeLevel ? <span className="mr-3">Level: {program.degreeLevel}</span> : null}
                {program?.status ? <span>Status: {program.status}</span> : null}
            </div>
            <div className="text-muted small">
                {program?.deliveryMode ? <span className="mr-3">Delivery: {program.deliveryMode}</span> : null}
                {(program?.creditRequirementMinimum || program?.creditRequirementMaximum)
                    ? <span>Credits: {program.creditRequirementMinimum ?? '—'}–{program.creditRequirementMaximum ?? '—'}</span>
                    : null}
            </div>
        </div>
    </div>
);

const formatMergeComments = (comments, destinationProgramId) => {
    if (!destinationProgramId) return comments;

    return comments.replace(
        /(Merged with program id\s+)\d+/gi,
        `$1${destinationProgramId}`
    );
};

export const MergeRequestView = ({ requestDetails }) => {
    const [mergeData, setMergeData] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (!requestDetails.requestID) return;
        setMergeData(null);
        setError(false);
        const res = academicProgramsService.getMergeProgramRequest(requestDetails.requestID);
        Promise.resolve(res)
            .then(data => setMergeData(data))
            .catch(() => setError(true));
    }, [requestDetails.requestID]);

    return (
        <div className="request-type-details">
            <h5 className="mb-1">Merge Request Details</h5>
            <hr className="mt-2 mb-3" />

            {mergeData === null && !error && (
                <p className="text-muted font-italic small">Loading program details…</p>
            )}

            {error && (
                <div className="alert alert-warning">Could not load program details.</div>
            )}

            {mergeData && (
                <>
                    <div className="d-flex align-items-start">
                        <ProgramCard heading="BEING ABSORBED" program={mergeData.sourceProgram} />
                        <div className="mx-3 mt-5 pt-2 text-muted">→</div>
                        <ProgramCard heading="SURVIVING PROGRAM" program={mergeData.destinationProgram} />
                    </div>

                    {requestDetails.additionalComments && (
                        <div className="mt-3">
                            <div className="text-muted small font-weight-bold">Comments</div>
                            <div>
                                {formatMergeComments(
                                    requestDetails.additionalComments,
                                    mergeData.destinationProgram?.programId
                                )}
                            </div>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};
